<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de histórico de permissão por lotação">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/administracao/relatorio-historico-permissao-lotacao/List'

export default {
    components: {
        List,
    },
}
</script>